var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mySuggestions" }, [
    _vm.$store.state.webNavigator == "pc"
      ? _c("div", [
          _c(
            "div",
            { staticClass: "my-advise" },
            [
              _c("div", { staticClass: "content-Tlt2" }, [
                _vm._v("我的投诉建议")
              ]),
              _c(
                "div",
                {
                  staticClass: "content-advise-p margintop20px lineheight15px"
                },
                [_vm._v("请输入您的联系方式，查看历史投诉建议信息")]
              ),
              _c("div", {
                staticClass: "popupShowAction",
                attrs: { id: "CaptchaId" }
              }),
              _c(
                "div",
                { staticClass: "margintop15px content-advise-p" },
                [
                  _c("span", { staticClass: "red" }, [_vm._v("*")]),
                  _c("span", { staticClass: "marginleft2px" }, [
                    _vm._v("联系手机 :")
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.phone1,
                        expression: "phone1"
                      }
                    ],
                    staticClass: "content-advise-input marginleft5px",
                    attrs: { maxlength: "11" },
                    domProps: { value: _vm.phone1 },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.phone1 = $event.target.value
                      }
                    }
                  }),
                  _c("span", { staticClass: "red marginleft40px" }, [
                    _vm._v("*")
                  ]),
                  _c("span", { staticClass: "marginleft2px" }, [
                    _vm._v("验证码 :")
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.code,
                        expression: "code"
                      }
                    ],
                    staticClass: "code-input marginleft5px",
                    attrs: { maxlength: "4" },
                    domProps: { value: _vm.code },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.code = $event.target.value
                      }
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      staticClass:
                        "marginleft5px suggestions-button suggestions-input-minBut",
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.getPicCode()
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.timer ? _vm.count + "s" : "获取验证码") +
                          "\n        "
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { attrs: { id: "my-code" } },
                    [
                      _c(
                        "el-dialog",
                        {
                          attrs: {
                            visible: _vm.dialogVisible3,
                            modal: true,
                            "close-on-click-modal": false,
                            "close-on-press-escape": false,
                            "show-close": false
                          },
                          on: {
                            "update:visible": function($event) {
                              _vm.dialogVisible3 = $event
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "codetitle content-advise-p" },
                            [_vm._v("提示")]
                          ),
                          _c("div", { staticClass: "content-adviseBox" }, [
                            _c("span", { staticClass: "content-advise-p" }, [
                              _c("span", { staticClass: "marginleft2px" }, [
                                _vm._v("验证码 :")
                              ]),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.code2,
                                    expression: "code2"
                                  }
                                ],
                                staticClass:
                                  "content-advise-input marginleft5px",
                                domProps: { value: _vm.code2 },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.code2 = $event.target.value
                                  }
                                }
                              })
                            ]),
                            _c("span", {
                              staticStyle: { "vertical-align": "middle" },
                              domProps: { innerHTML: _vm._s(this.picCode) },
                              on: {
                                click: function($event) {
                                  return _vm.picCodeData()
                                }
                              }
                            })
                          ]),
                          _c(
                            "div",
                            { staticClass: "submitcode" },
                            [
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.close("1")
                                    }
                                  }
                                },
                                [_vm._v("取 消")]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticClass: "marginleft9px",
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.phoneCodeData()
                                    }
                                  }
                                },
                                [_vm._v("确 定")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "button",
                {
                  staticClass: "suggestions-button suggestions-bigBut",
                  class: {
                    marginbottom172px:
                      _vm.flagTime == false && _vm.flagTime1 == false
                  },
                  on: {
                    click: function($event) {
                      return _vm.seeAdvise()
                    }
                  }
                },
                [_vm._v("查看\n      ")]
              ),
              _vm.flagTime == true
                ? _c("div", { staticClass: "margintop29px my-advise-tips" }, [
                    _vm._v("无历史投诉建议信息!")
                  ])
                : _vm._e(),
              _vm.flagTime1 == true
                ? _c(
                    "el-table",
                    {
                      staticClass: "margintop25px marginbottom70px",
                      staticStyle: { width: "83%" },
                      attrs: { data: _vm.myadvise, border: "" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "提交时间", width: "180" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        !scope.row.contants
                                          ? ""
                                          : _vm.$myConvertTimeDetails(
                                              scope.row.contants[0].createdAt
                                            )
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1184315753
                        )
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "type",
                          label: "反馈类型",
                          width: "180"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        !scope.row.type ? "" : scope.row.type
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          636220693
                        )
                      }),
                      _c("el-table-column", {
                        attrs: { label: "详细内容" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("div", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          !scope.row.contants
                                            ? ""
                                            : scope.row.contants[0].content
                                        )
                                      )
                                    ]),
                                    scope.row.contants &&
                                    scope.row.contants.length > 1
                                      ? _c("span", [
                                          _vm._v(
                                            "\n\n                 \n                ("
                                          ),
                                          _c("span", { staticClass: "blue1" }, [
                                            _vm._v("补充内容: ")
                                          ]),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.contants[1].content
                                                  ? scope.row.contants[1]
                                                      .content
                                                  : ""
                                              ) + ")"
                                            )
                                          ])
                                        ])
                                      : _vm._e()
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3167797405
                        )
                      }),
                      _c("el-table-column", {
                        attrs: { label: "反馈回复" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("div", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          !scope.row.replys
                                            ? ""
                                            : scope.row.replys[0].content
                                        )
                                      )
                                    ]),
                                    scope.row.replys &&
                                    scope.row.replys.length > 1
                                      ? _c("span", [
                                          _vm._v(
                                            "\n\n               \n              ("
                                          ),
                                          _c("span", { staticClass: "blue1" }, [
                                            _vm._v("补充回复: ")
                                          ]),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.replys[1].content
                                                  ? scope.row.replys[1].content
                                                  : ""
                                              ) + ")"
                                            )
                                          ])
                                        ])
                                      : _vm._e()
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3339493426
                        )
                      }),
                      _c("el-table-column", {
                        attrs: { label: "回复时间" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        !scope.row.replys
                                          ? ""
                                          : _vm.$myConvertTimeDetails(
                                              scope.row.replys[0].createdAt
                                            )
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          947621993
                        )
                      }),
                      _c("el-table-column", {
                        attrs: { label: "反馈结果" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  !scope.row.replys ||
                                  scope.row.replys.type == 0
                                    ? _c("div", { staticClass: "red" }, [
                                        _vm._v("未回复")
                                      ])
                                    : _c("div", [_vm._v("已回复")])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2660621206
                        )
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            scope.row.contants &&
                                            scope.row.contants.length < 2,
                                          expression:
                                            "scope.row.contants && scope.row.contants.length <2"
                                        }
                                      ],
                                      staticClass: "blue",
                                      on: {
                                        click: function($event) {
                                          return _vm.addAdvise(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("补充反馈内容")]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2127885764
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { attrs: { id: "add_advise" } },
                [
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        visible: _vm.dialogVisible1,
                        "show-close": true,
                        modal: true
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogVisible1 = $event
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "add_title" }, [
                        _vm._v("补充反馈内容")
                      ]),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.content1,
                            expression: "content1"
                          }
                        ],
                        staticClass: "add_content",
                        attrs: {
                          placeholder:
                            "回复如未能解决您的问题，欢迎继续补充内容说明!",
                          type: "text",
                          maxlength: "200"
                        },
                        domProps: { value: _vm.content1 },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.content1 = $event.target.value
                          }
                        }
                      }),
                      _c(
                        "button",
                        {
                          staticClass: "add-advise-button",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.onAddClick()
                            }
                          }
                        },
                        [_vm._v("提交")]
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { attrs: { id: "suc" } },
                [
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        visible: _vm.dialogVisible,
                        "show-close": false,
                        modal: true,
                        "close-on-click-modal": false,
                        "close-on-press-escape": false
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogVisible = $event
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "dialog_time" }, [
                        _vm._v("(" + _vm._s(_vm.totalTime) + "S)")
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      : _c("div", [
          _c("div", { staticClass: "phone-my-advise" }, [
            _c("div", { staticClass: "phone-title" }, [_vm._v("我的投诉建议")]),
            _c("div", { staticClass: "phone-p" }, [
              _vm._v("请输入您的联系方式，查看历史投诉建议信息")
            ]),
            _c(
              "div",
              { staticClass: "martop40px marleft137px banner-advise-p1" },
              [
                _c("span", { staticClass: "red1" }, [_vm._v("*")]),
                _c("span", { staticClass: "marleft14px" }, [
                  _vm._v("联系手机 :")
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.phone1,
                      expression: "phone1"
                    }
                  ],
                  staticClass: "banner-input marleft14px",
                  attrs: { type: "text", maxlength: "11" },
                  domProps: { value: _vm.phone1 },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.phone1 = $event.target.value
                    }
                  }
                })
              ]
            ),
            _c(
              "div",
              { staticClass: "martop20px marleft161px banner-advise-p1" },
              [
                _c("span", { staticClass: "red1" }, [_vm._v("*")]),
                _c("span", { staticClass: "marleft14px" }, [
                  _vm._v("验证码 :")
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.code,
                      expression: "code"
                    }
                  ],
                  staticClass: "banner-input1 marleft14px",
                  attrs: { type: "text", maxlength: "4" },
                  domProps: { value: _vm.code },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.code = $event.target.value
                    }
                  }
                }),
                _c(
                  "button",
                  {
                    staticClass: "banner-input1-but",
                    on: {
                      click: function($event) {
                        return _vm.getPicCode()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.timer ? _vm.count + "s" : "获取验证码"))]
                )
              ]
            ),
            _c("div", { staticClass: "martop61px" }, [
              _c(
                "button",
                {
                  staticClass: "suggestions-button1 suggestions-bigBut",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.goBack()
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "button",
                {
                  staticClass: "suggestions-button2 suggestions-bigBut",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.checkPhoneMess()
                    }
                  }
                },
                [_vm._v("查看")]
              )
            ])
          ]),
          _c(
            "div",
            { staticClass: "phone-popup-box" },
            [
              _c(
                "el-dialog",
                {
                  staticClass: "suggestions-popup",
                  attrs: {
                    visible: _vm.dialogVisible3,
                    modal: true,
                    "close-on-click-modal": false,
                    "close-on-press-escape": false,
                    "show-close": false
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogVisible3 = $event
                    }
                  }
                },
                [
                  _c("div", { staticClass: "codetitle content-advise-p" }, [
                    _vm._v("提示")
                  ]),
                  _c("div", { staticClass: "content-adviseBox" }, [
                    _c("span", { staticClass: "content-advise-p" }, [
                      _c("span", { staticClass: "font30phone" }, [
                        _vm._v("验证码： ")
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.code2,
                            expression: "code2"
                          }
                        ],
                        staticClass: "content-advise-input marginleft5px",
                        domProps: { value: _vm.code2 },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.code2 = $event.target.value
                          }
                        }
                      })
                    ]),
                    _c("span", {
                      staticClass: "popup-pic",
                      staticStyle: { "vertical-align": "middle" },
                      domProps: { innerHTML: _vm._s(this.picCode) },
                      on: {
                        click: function($event) {
                          return _vm.picCodeData()
                        }
                      }
                    })
                  ]),
                  _c("div", { staticClass: "submitcode" }, [
                    _c(
                      "button",
                      {
                        staticClass: "suggestions-button-popup displayIB",
                        on: {
                          click: function($event) {
                            return _vm.close("1")
                          }
                        }
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass:
                          "suggestions-button-popup marginleft9px displayIB",
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.phoneCodeData()
                          }
                        }
                      },
                      [_vm._v("确 定")]
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { id: "suc" } },
            [
              _c(
                "el-dialog",
                {
                  attrs: {
                    visible: _vm.dialogVisible,
                    "show-close": false,
                    modal: true,
                    "close-on-click-modal": false,
                    "close-on-press-escape": false
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogVisible = $event
                    }
                  }
                },
                [
                  _c("span", { staticClass: "dialog_time" }, [
                    _vm._v("(" + _vm._s(_vm.totalTime) + "S)")
                  ])
                ]
              )
            ],
            1
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-489d3538", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-489d3538","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/about/mySuggestions/mySuggestions.vue
// module id = 1214
// module chunks = 9